import { render, staticRenderFns } from "./WithdrawChannelSelect.vue?vue&type=template&id=1538ddac&scoped=true&lang=html"
import script from "./WithdrawChannelSelect.vue?vue&type=script&lang=js"
export * from "./WithdrawChannelSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1538ddac",
  null
  
)

export default component.exports